import type { ReactNode } from 'react'
import { ArrowLeft } from 'lucide-react'
import { Link, useParams } from 'react-router'
import { CollectionCard } from '@/features/collectionKeywords/CollectionKeywordsPage'
import { CollectionKeywordNav } from '@/features/collectionKeywords/CollectionKeywordNav'
import { useCollectionKeywordDetail } from '@/features/collectionKeywords/useCollectionKeywords'

export function CollectionKeywordDetailPage(): ReactNode {
  const collectionId = Number(useParams<{ collectionId: string }>().collectionId)
  const { data, isLoading, error } = useCollectionKeywordDetail(collectionId)

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
      <CollectionKeywordNav />
      <div className="mb-5 flex justify-end">
        <Link
          to="/collection-keywords/analysis"
          className="inline-flex items-center gap-2 rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-semibold dark:border-slate-700"
        >
          <ArrowLeft size={16} /> Zur Collection-Analyse
        </Link>
      </div>
      {isLoading ? (
        <div className="h-72 animate-pulse rounded-2xl bg-white dark:bg-slate-900" />
      ) : error !== null ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 p-5 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-100">
          Die Collection konnte nicht geladen werden.
        </div>
      ) : data === null || data === undefined ? (
        <div className="rounded-2xl border border-dashed p-12 text-center">
          Collection nicht gefunden.
        </div>
      ) : (
        <CollectionCard summary={data.summary} keywords={data.keywords} />
      )}
    </div>
  )
}
